import { rest } from 'msw'
import mockApiKeys from '../../../__mocks__/ApiKeys/apiKeys.json'
import mockApiKeyResponse from '../../../__mocks__/ApiKeys/apiKeyResponse.json'
import { ApiKeyCreateAPIRequest, ApiKey } from 'types/apiKeys'

const getAllApiKeys = rest.get<ApiKey[]>(`${API_URL}/api/token/withdraw`, async (req, res, ctx) => {
  return res(ctx.json(mockApiKeys))
})

const postCreateApiKey = rest.post<ApiKeyCreateAPIRequest>(
  `${API_URL}/api/v1/token`,
  async (req, res, ctx) => {
    return res(ctx.json(mockApiKeyResponse))
  }
)

export default [getAllApiKeys, postCreateApiKey]
